var map = {
	"./上海/官网/5.jpg": 1468,
	"./北京/官网/5.jpg": 69979,
	"./南京/官网/5.jpg": 93563,
	"./广州/官网/5.jpg": 72086,
	"./成都/官网/5.jpg": 29804,
	"./杭州/官网/5.jpg": 29199,
	"./武汉/官网/5.jpg": 58601,
	"./深圳/官网/5.jpg": 30355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54006;